import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/about_chart.png';
import _imports_1 from '@/assets/logo/icho_about_bg.png';
const _withScopeId = n => (_pushScopeId("data-v-c148b7d8"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "fs-s"
};
const _hoisted_2 = {
  class: "block block1"
};
const _hoisted_3 = {
  class: "main-width main_box"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "fs-xl text-white slogan"
}, [/*#__PURE__*/_createTextVNode("使用了WELL碳手印标准的公司"), /*#__PURE__*/_createElementVNode("br"), /*#__PURE__*/_createTextVNode("表现会比同行更出色")], -1));
const _hoisted_5 = ["innerHTML"];
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "mask"
}, null, -1));
const _hoisted_7 = {
  class: "block block2_0"
};
const _hoisted_8 = {
  class: "main-width d-flex jc-between ai-center content_box"
};
const _hoisted_9 = /*#__PURE__*/_createStaticVNode("<div class=\"fs-l text-blue title\" data-v-c148b7d8>关于WELL碳手印</div><div class=\"fs-xl pt-10 fw-b slogan\" data-v-c148b7d8>以人为本·主动减碳</div><div class=\"fs-m pt-40 pb-20 list_item\" data-v-c148b7d8><span class=\"fs-l t_color item_title\" data-v-c148b7d8>管理升级：</span>精细化/精准化/高频化</div><div class=\"fs-m pb-20 list_item\" data-v-c148b7d8><span class=\"fs-l t_color item_title\" data-v-c148b7d8>减负降耗：</span>数据化/孪生化/智能化</div><div class=\"fs-m pb-20 list_item\" data-v-c148b7d8><span class=\"fs-l t_color item_title\" data-v-c148b7d8>提速增效：</span>标准化/对标化/自主化</div>", 5);
const _hoisted_14 = ["innerHTML"];
const _hoisted_15 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0
}, null, -1));
const _hoisted_16 = {
  class: "block block2 bg-bggray"
};
const _hoisted_17 = {
  class: "main-width d-flex jc-between ai-center content_box"
};
const _hoisted_18 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "fs-l text-blue title"
}, "国际碳手印组织(ICHO)", -1));
const _hoisted_19 = ["innerHTML"];
const _hoisted_20 = /*#__PURE__*/_createStaticVNode("<div class=\"img_box\" data-v-c148b7d8><img src=\"" + _imports_1 + "\" width=\"320\" data-v-c148b7d8><div class=\"title_box\" data-v-c148b7d8><div class=\"img_box_title pb-2\" data-v-c148b7d8>ICHO</div><div class=\"img_box_subtitle\" data-v-c148b7d8>国际碳手印组织</div></div></div>", 1);
const _hoisted_21 = {
  class: "block block3"
};
const _hoisted_22 = {
  class: "main-width text-white content_box"
};
const _hoisted_23 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title fs-l pb-20 text-orange"
}, "为什么与我们合作？", -1));
const _hoisted_24 = ["innerHTML"];
const _hoisted_25 = {
  class: "earning_list pt-20"
};
const _hoisted_26 = ["src"];
const _hoisted_27 = {
  class: "fw-b pb-10"
};
const _hoisted_28 = {
  class: "item_bottom"
};
export default {
  __name: 'About',
  setup(__props) {
    const textData = {
      block1: '最近我们跟踪了使用WELL碳手印标准的企业，<br>观察他们在数字化、智能化上的提升，<br>发现他们比其他企业的资产升值率高出30%。',
      block2_0: '充分运用数字化和智能化技术，积极开发、采集、聚合需求侧<br>数据资源，与用户共建数智管控体系（在对能效/物效/坪效/人<br>效进行计量、监测和管控的基础上，建立基准、明确目标、制<br>定数智策略，实现精准管控）；在保护用户权益的基础上，协<br>力推进数据资源资产化、增值化。',
      block2: '全球首部碳手印标准由国际WELL建筑研究院指导,<br>国际碳手印组织发起并负责推广。国际碳手印组织<br>集合各行业专家的创新研发成果，主导或推动碳手<br>印计量、监测与评价技术发展，以论坛、投资、倡<br>议、辅导、评级等方式开展碳手印活动，致力于激<br>发并带动更多产业实践，为社会和企业持续创造经<br>济和文化价值。',
      block3: 'WELL碳手印集合各行业专家的创新研发成果，主导或推动聚焦型碳行动准则、技术导<br>则和运营管理评价体系，让实际的碳行动有标准可循，并激发更多的产业实践。',
      block4: '我们遍布全球的优秀网络能够帮助您在<br>业务的各个方面创造价值。'
    };
    const earningList = [{
      title: '持续提升降本增效能力',
      content: '通过WELL碳手印标准优化更新企业各项经营指标和目标，并通过数字驱动实现降本增效。',
      url: require('@/assets/about_report.png')
    }, {
      title: '营造更有活力的组织文化',
      content: '通过WELL碳手印活动将产业最佳实践思想和创意融入到组织文化中，激发组织活力。',
      url: require('@/assets/about_heart.png')
    }, {
      title: '满足多层次组织需求',
      content: '同时在产品与服务保障、成本与费用控制、体验与感受提升、创意与文化促进等多层次满足组织需求。',
      url: require('@/assets/about_team.png')
    }, {
      title: '创造多维度组织价值',
      content: '同时在产品与服务、组织与运营、品牌与模式等多个维度创造组织价值。',
      url: require('@/assets/about_company.png')
    }];
    return (_ctx, _cache) => {
      const _component_el_image = _resolveComponent("el-image");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_hoisted_4, _createElementVNode("div", {
        class: "text-white pt-40 text_des",
        innerHTML: textData.block1
      }, null, 8, _hoisted_5)]), _createVNode(_component_el_image, {
        class: "bg-el-img",
        src: require('@/assets/about_block_1.jpg'),
        fit: "cover"
      }, null, 8, ["src"]), _hoisted_6]), _createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_createElementVNode("div", null, [_hoisted_9, _createElementVNode("div", {
        class: "fs-xs text-gray pt-40 pb-40 tip",
        innerHTML: textData.block2_0
      }, null, 8, _hoisted_14)]), _hoisted_15])]), _createElementVNode("div", _hoisted_16, [_createElementVNode("div", _hoisted_17, [_createElementVNode("div", null, [_hoisted_18, _createElementVNode("div", {
        class: "fs-m pt-20 pb-40 des",
        innerHTML: textData.block2
      }, null, 8, _hoisted_19)]), _hoisted_20])]), _createElementVNode("div", _hoisted_21, [_createElementVNode("div", _hoisted_22, [_hoisted_23, _createElementVNode("div", {
        class: "title fs-m pb-20",
        innerHTML: textData.block3
      }, null, 8, _hoisted_24), _createElementVNode("div", _hoisted_25, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(earningList, (item, idx) => {
        return _createElementVNode("div", {
          class: "list-item pb-40",
          key: idx
        }, [_createElementVNode("img", {
          src: item.url
        }, null, 8, _hoisted_26), _createElementVNode("div", _hoisted_27, _toDisplayString(item.title), 1), _createElementVNode("div", _hoisted_28, _toDisplayString(item.content), 1)]);
      }), 64))])])])]);
    };
  }
};